import CdkSharing from "./CdkSharing.vue";

export default CdkSharing;
